export const confirmEmailText = {
  title: 'Verify your email address',
  subtitle: 'Activate your account by entering the code sent to your email',
  code: 'Code',
  submit: 'Activate account',
  didntGetACode: 'Didn’t get the code? Retry now!',
  goBack: 'Go back',
};
